import(/* webpackMode: "eager" */ "/app/apps/web-tms/src/app/[locale]/(auth)/login/page.tsx");
